import type { JobInvoiceStatus } from '../types/job';

export const JOB_INVOICE_STATUS_CONFIG: Record<JobInvoiceStatus, { label: string; className: string }> = {
  not_invoiced: {
    label: 'Not Invoiced',
    className: 'bg-gray-100 text-gray-800 border-gray-300',
  },
  needs_review: {
    label: 'Needs Review',
    className: 'bg-orange-100 text-orange-800 border-orange-300',
  },
  ready_to_send: {
    label: 'Ready to Send',
    className: 'bg-amber-100 text-amber-800 border-amber-300',
  },
  invoice_sent: {
    label: 'Invoice Sent',
    className: 'bg-blue-100 text-blue-800 border-blue-300',
  },
  partially_paid: {
    label: 'Partially Paid',
    className: 'bg-teal-100 text-teal-800 border-teal-300',
  },
  paid: {
    label: 'Paid',
    className: 'bg-green-100 text-green-800 border-green-300',
  },
};

export function getJobInvoiceStatusLabel(status: JobInvoiceStatus): string {
  return JOB_INVOICE_STATUS_CONFIG[status].label;
}

export const JOB_INVOICE_STATUS_OPTIONS = (Object.keys(JOB_INVOICE_STATUS_CONFIG) as JobInvoiceStatus[]).map(
  (value) => ({ value, label: JOB_INVOICE_STATUS_CONFIG[value].label })
);
